module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dabdbab5966f0f9d5d3f40e79f00c0a3.png";